/** Detect LLM refusal / safety boilerplate in generated drafts. */
const REFUSAL_PATTERNS = [
  /i can'?t fulfill your request/i,
  /i cannot create a post/i,
  /i can'?t help with/i,
  /is there anything else i can help/i,
  /i can'?t fulfill/i,
];

export function looksLikeRefusal(content: string): boolean {
  return REFUSAL_PATTERNS.some((pattern) => pattern.test(content));
}

export function draftHasRefusal(
  drafts: Record<string, { content?: string }>
): boolean {
  return Object.values(drafts).some((d) => d.content && looksLikeRefusal(d.content));
}
